var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.957 6.043a1 1 0 0 1 0 1.414l-10.5 10.5a1 1 0 0 1-1.414 0l-5.25-5.25a1 1 0 1 1 1.414-1.414l4.543 4.543 9.793-9.793a1 1 0 0 1 1.414 0"
  })));
};
export default SvgIconCheck;